export const TRAFFIC_PERCENT_VALUES = {
  DEFAULT: 90,
  WARNING: 20,
} as const
